import { reportError } from "utils/errorReporting";

interface ConvertDollarsToCentsArgs {
  dollars: number | string;
  returnType?: "number" | "string";
}

export function convertDollarsToCents({
  dollars,
  returnType = "number",
}: ConvertDollarsToCentsArgs): number | string | null {
  const dollarsNumber = typeof dollars === "string" ? Number(dollars) : dollars;

  if (!Number.isFinite(dollarsNumber)) {
    reportError(`convertDollarsToCents`, new Error("Invalid input: dollars is not a finite number"), {
      context: { dollars, returnType },
    });
    return null;
  }

  const cents = Math.round(dollarsNumber * 100);

  if (returnType === "string") {
    return cents.toString();
  }

  return cents;
}
